export default __webpack_public_path__ + "static/hotel-0866b33e35c87af8fe776dff7f6e9b71.jpg";